// src/utils/stripBankEmailFooter.js
// ============================================================================
// Strip the trailing boilerplate footer from a bank credit-alert email so the
// Payment Inbox preview shows only the transaction details.
//
// HDFC (and similar) alerts end with a call-centre line, a sign-off, marketing,
// and a copyright notice — none of which carry reconciliation value:
//   "For real-time account balance, please call 1800 270 3333."
//   "Thank you for banking with HDFC Bank."
//   "Warm Regards, HDFC Bank ... For more details on Service charges ... © HDFC Bank"
//
// Everything from the first footer marker to the end of the body is removed.
// The markers are footer-specific phrases that do not occur in the transaction
// block (Amount received / Account / Date / Reference Details), so the useful
// content above them is preserved. Note: "For real-time account balance" is a
// call-to-action, not a figure — redactBankBalance deliberately leaves it, so it
// is removed here instead.
//
// This is display-only cleanup: the footer is not sensitive (unlike the account
// balance, which is purged at ingest). Applied in the InvoicesPage Payment Inbox
// preview after redactBankBalance. Covered by
// src/utils/__tests__/stripBankEmailFooter.test.js.
// ============================================================================

// Footer starts at the first of these markers; \s* also swallows the blank line
// before it so the kept content ends cleanly on the last transaction line.
const FOOTER_RE =
  /\s*(?:for real-?time account balance|thank you for banking|warm regards|this is a system[\s-]*generated)\b[\s\S]*$/i;

/**
 * Remove the trailing bank-email footer boilerplate. Returns the input
 * unchanged when it is empty/nullish or has no recognisable footer.
 *
 * @param {string|null|undefined} body - email body text (already balance-redacted)
 * @returns {string|null|undefined} body with the footer removed
 */
export function stripBankEmailFooter(body) {
  if (!body) return body;
  return body.replace(FOOTER_RE, '').trimEnd();
}

export default stripBankEmailFooter;
